import moment from 'moment';

/** How a suggested or filled value reads to a recruiter (JT1-1764). Values are the backend's enrichment shapes. */

const NOTICE: Record<string, string> = {
  immediate: 'Immediate',
  one_week: '1 week',
  two_weeks: '2 weeks',
  three_weeks: '3 weeks',
  one_month: '1 month',
  two_months: '2 months',
  three_months: '3 months',
};

const SIZE: Record<string, string> = {
  _50: 'Up to 50 staff',
  '51_100': '51 to 100 staff',
  '101_200': '101 to 200 staff',
  '201_500': '201 to 500 staff',
  '501_': 'Over 500 staff',
};

const PERIOD: Record<string, string> = { hour: 'an hour', day: 'a day', week: 'a week', month: 'a month', year: 'a year' };

const humanise = (value: string) => {
  const text = value.replace(/_/g, ' ');
  return text.charAt(0).toUpperCase() + text.slice(1);
};

const money = (amount: number) => `$${Math.round(amount).toLocaleString('en-AU')}`;

export function formatFindingValue(field: string, value: unknown): string {
  if (value === null || value === undefined || value === '') return 'Empty';
  if (Array.isArray(value)) {
    if (!value.length) return 'Empty';
    if (field === 'salary_expectations') {
      return (value as { min_amount: number; max_amount: number; period: string }[])
        .map((s) => `${s.min_amount === s.max_amount ? `${money(s.min_amount)}+` : `${money(s.min_amount)} to ${money(s.max_amount)}`} ${PERIOD[s.period] ?? s.period}`)
        .join('; ');
    }
    return (value as string[]).map(humanise).join(', ');
  }
  if (field === 'availability' && typeof value === 'object') {
    const availability = value as { status: string; available_from?: string | null };
    if (availability.status === 'available_soon' && availability.available_from) {
      return `Available from ${moment(availability.available_from).format('D MMM YYYY')}`;
    }
    return humanise(availability.status);
  }
  if (field === 'notice_period') return NOTICE[String(value)] ?? humanise(String(value));
  if (field === 'size') return SIZE[String(value)] ?? String(value);
  if (field === 'contact_type') return humanise(String(value));
  return String(value);
}

export function formatDue(dueAt: string | null, hasTime: boolean): string {
  if (!dueAt) return 'No due date';
  return moment(dueAt).format(hasTime ? 'ddd D MMM, h:mm a' : 'ddd D MMM');
}

export const TASK_TYPE_LABELS: Record<string, string> = {
  call: 'Call',
  email: 'Email',
  to_do: 'To do',
  general: 'General',
};
